
export const blogTranslations = {
  // Navigation and general UI
  blog: 'Blog',
  blogDescription: 'Discover articles and tips to improve your productivity and wellbeing',
  latestPosts: 'Latest Posts',
  noPostsYet: 'No posts available yet',
  loading: 'Loading...',
  backToBlog: 'Back to Blog',
  postNotFound: 'Post not found',

  // Administration
  managePosts: 'Manage Posts',
  newPost: 'New Post',
  editPost: 'Edit Post',
  publishPost: 'Publish',
  saveDraft: 'Save Draft',
  saving: 'Saving...',
  postCreated: 'Post created successfully',
  postUpdated: 'Post updated successfully',
  postDeleted: 'Post deleted successfully',
  confirmDeletePost: 'Delete post?',
  confirmDeletePostDesc: 'This action cannot be undone. The post will be permanently deleted.',

  // States
  published: 'Published',
  draft: 'Draft',

  // Form
  postTitle: 'Title',
  postExcerpt: 'Excerpt',
  postContent: 'Content',
  postCategory: 'Category',
  postImage: 'Image',
  uploadImage: 'Upload Image',
  uploading: 'Uploading...',
  removeImage: 'Remove Image',
  imageUploaded: 'Image uploaded successfully',
  imageUploadError: 'Error uploading image',
  hasImage: 'Has image',

  // Categories
  finances: 'Finance',
  timeManagement: 'Time Management',
  productivity: 'Productivity',
  personalDevelopment: 'Personal Development',
  other: 'Other',

  // Validations
  titleRequired: 'Title is required',
  titleMinLength: 'Title must be at least 5 characters',
  titleMaxLength: 'Title cannot exceed 200 characters',
  excerptMaxLength: 'Excerpt cannot exceed 300 characters',
  contentRequired: 'Content is required',
  contentMinLength: 'Content must be at least 50 characters',
  categoryRequired: 'Category is required',

  // Common actions
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  success: 'Success',
  error: 'Error',

  // SEO
  seoTitle: 'SEO Title',
  seoDescription: 'Meta Description',
  seoKeywords: 'Keywords',
  slug: 'Slug',
};

// Export as named export for compatibility
export const blog = blogTranslations;
